//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};